


export function transformCartToDesiredArray(cartItems:any) {
    const newArray:any = [];
  console.log(cartItems);
    cartItems.forEach((item:any) => {
      const newItem = {
        booking_extra_id: item.booking_extra_id,
        quantity: item.quantity,
        values: item.values.map((value:any) => ({
          id: value.id,
          value: value.value
        }))
      };
  
      newArray.push(newItem);
    });

  
    return newArray;
  }
  // export function handleExtrasfields(fields:any) {
  //   const newArray:any = [];
  
  //   fields.forEach((item:any) => {
  //     const newItem = {
  //       id: item.id,
  //       value: item.value
  //     };
  
  //     newArray.push(newItem);
  //   });

  
  //   return newArray;
  // }

export const handleGlobalCheckout = async (freezScreenState: any,setPaymentMethodPopUp: any,alertMessageState: any, state: any, apiState: any,paymentMethod:any) => {

    // setPaymentMethodPopUp(false)
    freezScreenState(true);
    let payload = {
        slot_id: state?.bookingForm?.slotId,
        guests:state?.bookingForm?.NoGuest,
        device_id: state?.deviceId,
        extras: transformCartToDesiredArray(state.cart),
        payment_source: paymentMethod,
        token: null,
        save_card: false,
        card_id: null


    }
    // const response : any = await apiService.addBookingCustomer(payload,state?.authToken);
    // console.log(response)
   
    // return response
    // alertMessageState({
    //   type: "error",
    //   show: true,
    //   message: response?.data?.message,
    // });

};  

